import gql from 'graphql-tag';

export default gql`
  fragment prospectCustomizeItemSelectOptionFragment on ProspectCustomizeItemSelectOption {
    id
    poolProspectCustomizeItemSelectOptionId
  }
`;
